import * as React from "react"
import { Typography, Box } from "@mui/material"
import {isEmpty} from "@ui-seeker/utils";

import {NotAllowedBlock} from "@components";
import {ConditionsBlock} from "../../@components";


export default function conditionColumn() {
	return [{
		name: "conditionsValue", label: "Conditions",
		options: {
			display: "excluded",
			customBodyRowRender: (value) => <Typography sx={{ textAlign: 'center'}}>
			Changes {value}
		</Typography>
		}
	}, {
		name: "conditionsLabel", label: 'Conditions',
		options: {
			filter: false,
			customBodyRowRender: (value) => {
				if (isEmpty(value) || !value)
					return <Box sx={{ display: 'flex', justifyContent: 'center'}}>
						<NotAllowedBlock />
					</Box>

				return <ConditionsBlock conditions={value} />
			}
		}
	}]
}